import React, { Component } from 'react';
import Footer from '../../components/layout/Footer';

import HeaderMeta from 'components/headerMeta/HeaderMeta';
import '../../assets/style/itemStyle/common.scss';

export default class PartnerWithUs extends Component {
  render() {
    return (
      <>
        <HeaderMeta type="partnerWithUs" />
        <div className="public-container partner-container">
          <div className="banner">
            <img
              src={require('../../assets/imgs/webp/partner-banner.webp').default}
              alt="partner banner"
            />
          </div>
          <div className="public-content services">
            <div className="banner_bg bg-image">
              <div className="describe">
                <h1 style={{ color: '#fff' }}>Partner With Us</h1>
                <p>
                  We are looking to expand our network of partners and are currently recruiting
                  partners in the US to add to our platform, airacer.com. Partnering with DOT/FAA
                  licensed air carriers and prestigious flight operators, Airacer provides clients
                  with the most convenient and reliable private flight services.
                </p>
                <div
                  className="link"
                  onClick={() => {
                    this.props.history.push('/contactUs');
                  }}
                >
                  <span>Contact US</span>
                </div>
              </div>
            </div>
            <div className="title">About Us</div>
            <ul className="list">
              <li>
                <img
                  src={require('../../assets/imgs/webp/partner-01.webp').default}
                  alt="Who We Are"
                />
                <div className="text-content">
                  <h3 className="tit">
                    <span>Who We Are</span>
                  </h3>
                  <p>
                    Airacer is a cloud-based Saas and B2B2C company specializing in the aviation
                    industry. It is the leading one-stop platform for private aviation, specializing
                    in flight private aviation experiences.
                  </p>
                </div>
              </li>
              <li>
                <img
                  src={require('../../assets/imgs/webp/partner-02.webp').default}
                  alt="Our Mission"
                />
                <div className="text-content">
                  <h3 className="tit">
                    <span>Our Mission</span>
                  </h3>
                  <p>
                    Our mission is to revolutionize the private aviation industry through the
                    introduction of digital solutions that streamline booking processes.
                  </p>
                </div>
              </li>
              <li>
                <img
                  src={require('../../assets/imgs/webp/partner-03.webp').default}
                  alt="We’re Growing"
                />
                <div className="text-content">
                  <h3 className="tit">
                    <span>We’re Growing</span>
                  </h3>
                  <p>
                    Since Airacer took off in 2015, we have accumulated 20,099 high-net-worth
                    customers all over the world. Especially, among Chinese-speaking demographic,
                    Airacer ranks No.1 in the world. We cover 90% of the Asian American market, with
                    60% of charter flight demand in the US.
                  </p>
                </div>
              </li>
            </ul>
            <div className="more">
              <a href="/aboutUs">More</a>
            </div>
            <div className="trait-content">
              <h3>Get Started Today</h3>
              <p>
                All we need is your API
                <br />
                Connect to our site within one business day
              </p>
              <ul>
                <li>
                  <img
                    src={require('../../assets/imgs/svg/card01.svg').default}
                    alt="Start Booking Flights in No Time"
                  />
                  <span>Start Booking Flights in No Time</span>
                </li>
                <li>
                  <img
                    src={require('../../assets/imgs/svg/card02.svg').default}
                    alt="Expand to the Asian American Market"
                  />
                  <span>Expand to the Asian American Market</span>
                </li>
                <li>
                  <img
                    src={require('../../assets/imgs/svg/card03.svg').default}
                    alt="Increase Revenue"
                  />
                  <span>Increase Revenue</span>
                </li>
                <li>
                  <img
                    src={require('../../assets/imgs/svg/card04.svg').default}
                    alt="Join our Strategic Partnership"
                  />
                  <span>Join our Strategic Partnership</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}
